module.exports = {
    version: __VERSION
}